"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent.js"));
var _consts = require("../consts.js");
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _cartApi = _interopRequireDefault(require("../../cartApi.js"));
var _urijs = _interopRequireDefault(require("urijs"));
var _IntentCartOperations = _interopRequireDefault(require("../components/IntentCartOperations"));
var _index = require("../../utils/index");
var _wixAppsApi = _interopRequireDefault(require("../gallery/wixAppsApi"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
var _photographyClientLib = require("@wix/photography-client-lib");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CheckoutIntent = /*#__PURE__*/function (_Component) {
  function CheckoutIntent() {
    var _this;
    _this = _Component.call(this) || this;
    _this.state = {
      ready: false,
      url: '',
      connectedProviders: undefined
    };
    _this.handleCheckoutMessageReceived = _this.handleCheckoutMessageReceived.bind(_this);
    if (_photographyClientLib.Wix) {
      _photographyClientLib.Wix.PubSub.subscribe(_consts.ARTSTORE_PUBSUB_ENUMS.REFRESH_CART, function () {
        _this.updateCartItems();
      }, true);
      _photographyClientLib.Wix.getSiteInfo(function (info) {
        var url = info.url;
        _this.setState({
          ready: true,
          url: url
        });
        _this.initConnectedProviders(url);
      });
      if (_index.utils.isMobile()) {
        _photographyClientLib.Wix.getBoundingRectAndOffsets(function (data) {
          var height = data.rect && data.rect.height;
          if (height && height > 0) {
            _photographyClientLib.Wix.setHeight(height);
          }
        });
      }
    }
    return _this;
  }
  (0, _inheritsLoose2["default"])(CheckoutIntent, _Component);
  var _proto = CheckoutIntent.prototype;
  _proto.initConnectedProviders = /*#__PURE__*/function () {
    var _initConnectedProviders = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
      var connectedProviders, queryParams, appDefId, api;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryParams = (0, _urijs["default"])(url).search(true);
            appDefId = queryParams.appDefId;
            if (!appDefId) {
              _context.next = 9;
              break;
            }
            api = _wixAppsApi["default"][appDefId];
            _context.next = 6;
            return api.getConnectedProviders(api.getInstanceFromSettings(queryParams), '//progallery.wixapps.net');
          case 6:
            connectedProviders = _context.sent;
            _context.next = 10;
            break;
          case 9:
            connectedProviders = _photographyClientLib.window.connectedProviders;
          case 10:
            this.setState({
              connectedProviders: connectedProviders
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function initConnectedProviders(_x) {
      return _initConnectedProviders.apply(this, arguments);
    }
    return initConnectedProviders;
  }();
  _proto.handleCheckoutMessageReceived = function handleCheckoutMessageReceived(type, payload, resolve, reject, providerId) {
    switch (type) {
      case _providerEvents["default"].sdkReady:
        this.updateCartItems();
        break;
      default:
        (0, _IntentCartOperations["default"])(type, payload, resolve, reject, providerId);
        break;
    }
  };
  _proto.updateCartItems = function updateCartItems() {
    var _this2 = this;
    var connectedProviders = this.state.connectedProviders;
    if (this.intent && connectedProviders) {
      var connectedProviderId = Object.keys(connectedProviders)[0];
      _cartApi["default"].getCartItems(connectedProviderId).then(function (items) {
        _this2.intent.postMessage(_providerEvents["default"].refreshCart, items);
      });
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    // window.fedopsAppName='art-store-checkout'
    (0, _photographyClientLib.appLoaded)();
  };
  _proto.render = function render() {
    var _this3 = this;
    var renderComponent = /*#__PURE__*/_react["default"].createElement("div", null);
    var _this$state = this.state,
      connectedProviders = _this$state.connectedProviders,
      url = _this$state.url,
      ready = _this$state.ready;
    if (ready && connectedProviders) {
      var search = (0, _urijs["default"])(url).search(true);
      renderComponent = /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], {
        api: new _WixSDKProviderApi["default"](_photographyClientLib.Wix),
        hiddenFromEditor: true,
        ref: function ref(element) {
          return _this3.intent = element;
        },
        intent: _consts.providerIntents.checkout,
        onMessageReceived: this.handleCheckoutMessageReceived,
        additionalParams: Object.assign({}, search),
        connectedProviders: connectedProviders
      });
    }
    return renderComponent;
  };
  return CheckoutIntent;
}(_react.Component);
module.exports = CheckoutIntent;